import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  label: {},
  progressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  progressContainerMultiLine: {
    marginTop: 10,
  },
  progressBarContainer: {},
  progressBarContainerOneLine: {
    width: 50,
    marginRight: 20,
  },
  progressBarContainerMultiLine: {
    flex: 1,
    marginRight: 60,
  },
  suffix: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
